import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-300);

  ${mediaQueries.tablet} {
    flex-direction: row;
  }
`

export const More = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  width: 100%;

  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300);
  letter-spacing: var(--font-letter-spacing-loose);

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 1;
    height: 1px;
    background: var(--border-secondary);
  }

  &::before {
    margin-right: var(--space-300);
  }

  &::after {
    margin-left: var(--space-300);
  }

  ${mediaQueries.tablet} {
    width: auto;

    font-size: var(--font-size-300);

    &::before,
    &::after {
      display: none;
    }

    &::after {
      content: ':';
      display: inline;
      margin-left: 0;
      background: none;
      height: auto;
      flex: none;
    }
  }
`
